<template>
  <div
    v-show="visible"
    class="drop-uploader-wrapper"
  >
    <el-upload
      v-show="uploaderVisible"
      ref="uploader"
      no="upload"
      class="drop-uploader"
      :drag="openDrag"
      :multiple="multiple"
      :auto-upload="autoUpload"
      :action="action"
      :headers="headers"
      :data="uploadParams"
      :file-list="fileList"
      :show-file-list="false"
      :before-upload="handleBeforeUpload"
      :on-progress="handleProgress"
      :on-success="handleSuccess"
      :on-error="handleError"
      :accept="fileAccept"
      :on-change="toChooseFile"
    >
      <div v-if="openDrag" class="drop-uploader-icon">
        <i class="el-icon-upload" />
        <p>{{ $t('Message.AboutToUploadFiles') }}</p>
      </div>
    </el-upload>
    <el-dialog
      :visible="resultDialogVisible"
      :title="$t('SeaExport.FileUpload')"
      width="800px"
      :close-on-click-modal="closeOnClickModal"
      @close="resultDialogClose"
    >
      <p style="text-align: right;margin:0">{{ $t('CargoMsg.Cargo_AllAmount') }}：{{ total }}{{ $t('CargoMsg.Cargo_Pcs') }}，<span style="color:green">{{ $t('Message.SuccessfullyUploaded') }}：{{ success }}{{ $t('CargoMsg.Cargo_Pcs') }}</span>，<span style="color:red">{{ $t('Message.Failure') }}：{{ fail }}个</span></p>
      <el-table
        :data="fileList"
        style="width: 100%;"
        max-height="400px"
      >
        <el-table-column
          prop="name"
          :label="$t('FileHistory.fileName')"
          width="180"
          align="center"
        />
        <el-table-column
          prop="raw.type"
          :label="$t('FileHistory.jobType')"
          width="180"
          align="center"
        />
        <el-table-column
          prop="size"
          :label="$t('FileHistory.fileSize')"
          width="180"
          align="center"
          :formatter="(row, column, cellValue, index)=>($numeral(cellValue/1024).format('0.00'))+'KB'"
        />
        <el-table-column
          prop="status"
          :label="$t('Message.UploadResults')"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status==='success'" style="color:green">{{ $t('queryJob.uploadSucceeded') }}</span>
            <span v-else-if="scope.row.status==='fail'" style="color:red">{{ $t('queryJob.uploadFailed') }}</span>
            <span v-else style="color:#1890ff"><i class="el-icon-loading" />{{ $t('queryJob.uploading') }}</span>
          </template>
        </el-table-column>
      </el-table></el-dialog>
  </div>
</template>
<script>
export default {
  name: 'DropUploader',
  props: {
    action: {
      type: String,
      default: () => ''
    },
    uploadParams: {
      type: Object,
      default: () => {}
    },
    accept: {
      type: Array,
      default: () => null
    },
    fileFormat: {
      type: String,
      default: () => ''
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    openDrag: {
      type: Boolean,
      default: true
    }, // 是否启用拖拽上传
    bsOpen: {
      type: Boolean,
      default: true
    },
    channelOpen: {
      type: Boolean,
      default: true
    },
    bsRemainingAmountEnough: { // 余额是否充足
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      uploaderVisible: false,
      isUploading: false, // 是否正在上传中
      resultDialogVisible: false,
      fileList: [],
      fileAccept: null,
      timer: null
    }
  },
  computed: {
    headers() {
      return {
        sessionId: this.$store.getters.token
      }
    },
    total() {
      return this.fileList.length
    },
    success() {
      return this.fileList.filter(f => f.status === 'success').length
    },
    fail() {
      return this.fileList.filter(f => f.status === 'fail').length
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        window.removeEventListener('dragleave', this.dragHandle)
      }
    }
  },
  created() {
    window.addEventListener('dragenter', this.dragHandle, true)
    document.addEventListener('mouseleave', this.leaveDocument, true)
  },
  beforeDestroy() {
    window.removeEventListener('dragenter', this.dragHandle)
    document.removeEventListener('mouseleave', this.leaveDocument)
  },
  methods: {
    handleBeforeUpload(file) {
      console.log(file)
      let canUpload = true
      if (!this.channelOpen) {
        this.$message.warning(this.$t('CargoMsg.Cargo_IdentificationCannotBePerformedTip'))
        return false
      }
      if (!this.bsOpen) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UnopenedService'))
        return false
      }
      if (!this.bsRemainingAmountEnough) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemainingAmountNotEnough'))
        return false
      }
      if (this.accept) {
        canUpload = false
        this.accept.forEach(item => {
          if (file.type) {
            if (file.type.includes(item)) {
              canUpload = true
            }
          } else {
            if (file.name.toLowerCase().includes(item)) {
              canUpload = true
            }
          }
        })
        if (!canUpload) {
          const exclude = ['msword', 'ms-excel', 'jpeg']
          const types = this.accept.filter(item => exclude.indexOf(item) === -1)
          this.$message.error(this.$t('Message.OnlyFilesFormatCanUploaded').replace('{0}', types.join('/')))
          return false
        }
      }
      if (!file.size) {
        this.$message.error(`${file.name}${this.$t('Message.VolumeAbnormalAndCannotUploaded')}`)
        return false
      }
      if (file.size && file.size > 20 * 1024 * 1024) {
        this.$message.error(`${file.name}${this.$t('Message.VolumeExceeds20mAndCannotUploaded')}`)
        return false
      }
      this.isUploading = false
      return true
    },
    handleProgress(event, file, fileList) {
      console.log(fileList)
      this.isUploading = true
      this.fileList = fileList
      if (this.uploaderVisible) {
        this.uploaderVisible = false
      }
      if (!this.resultDialogVisible || !this.visible) {
        this.visible = true
        this.resultDialogVisible = true
      }
    },
    handleSuccess(res, file, fileList) {
      // CARGO-44204 文件上传漏洞
      const errors = res.errors || []
      if (!res.data && errors && errors.length > 0) {
        for (const fileListElement of this.fileList) {
          fileListElement.status = 'fail'
        }
        const errorMsg = errors[0].message
        this.$message.error(errorMsg)
      }
      this.isUploading = false
      this.$emit('upload-result', res.data)
      this.$emit('upload-result-file', file)
    },
    // eslint-disable-next-line handle-callback-err
    handleError(err, file, fileList) {
      if (!this.isUploading && !this.resultDialogVisible) {
        this.visible = false
        this.uploaderVisible = false
      }
      this.isUploading = false
    },
    toChooseFile(file) {
      if (!this.autoUpload) {
        this.uploaderVisible = false
        this.resultDialogVisible = false
        this.visible = false
        this.fileList = []
        this.$emit('choose-file', file)
      }
    },
    dragHandle(e) {
      if (!e) {
        this.visible = false
        this.uploaderVisible = false
        this.resultDialogVisible = false
      }
      if (!this.openDrag) {
        this.visible = false
        this.uploaderVisible = false
        this.resultDialogVisible = false
        return
      }
      e.preventDefault()
      this.fileAccept = ''
      const { type, fromElement, target } = e
      console.log('dragHandle', e)
      if (type === 'drop' && this.uploaderVisible === true) {
        this.visible = false
        this.uploaderVisible = false
      }
      if (type === 'dragenter') {
        if (!this.uploaderVisible) {
          this.visible = true
          this.uploaderVisible = true
        }
      }
      if (type === 'dragleave') {
        if ((target.className.includes('el-upload-dragger') || target.className.includes('el-icon-upload')) && !fromElement) {
          this.visible = false
          this.uploaderVisible = false
          this.resultDialogVisible = false
        }
      }
    },
    resultDialogClose() {
      this.uploaderVisible = false
      this.resultDialogVisible = false
      this.visible = false
      this.fileList = []
      this.$emit('upload-end')
    },
    triggeFileSelectWindow() {
      if (!this.visible) {
        this.fileAccept = this.fileFormat
        this.$nextTick(() => {
          this.$refs.uploader.$refs['upload-inner'].$refs.input.click()
        })
      }
    },
    leaveDocument(e) {
      this.uploaderVisible = false
      if (!this.resultDialogVisible) {
        this.visible = false
      }
      e.preventDefault()
    }
  }
}
</script>
<style lang="scss">
.drop-uploader-wrapper{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .drop-uploader {
    position: relative;
    height:100%;
    z-index: 9999;
    .el-upload {
      width: 100%;
      height: 100%;
      &-dragger {
        width: 100%;
        height: 100%;
        background-color: transparent;
        &.is-dragover{
          background-color: rgba(24, 144, 225,.1);
          .drop-uploader-icon {
            color: #1890ff;
            .el-icon-upload{
              color: #1890ff;
            }
          }
        }
      }
    }
    &-icon {
      display: inline-block;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      font-size: 48px;
      color:#C0C4CC;
      .el-icon-upload {
        font-size: 200px;
      }
    }
  }
}
</style>
